import { isNullOrEmpty } from '../helpers/LanguageHelpers';
import Swal from 'sweetalert2';

/* 
 * Icons are string:  success, error, warning, info, question
 */

function alertPopup(type, message, title = null, confirmButtonText = "Got It") {
    return Swal.fire({
        title: title,
        text: message,
        icon: type,
        confirmButtonText: confirmButtonText,
        allowOutsideClick: false,
        keydownListenerCapture: true
    });
}

function confirmPopup(type, message, title = null, confirmText = "OK", cancelText = "Cancel", confirmHandler = null, cancelHandler = null) {
    Swal.fire({
        title: title,
        text: message,
        icon: type,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        showCancelButton: true,
        showConfirmButton: true,
        allowOutsideClick: false
    }).then((result) => {
        if (result.isConfirmed && confirmHandler) {
            confirmHandler();
        }
        else if (result.isDenied && cancelHandler) {
            cancelHandler();
        }
    });
}

function apiErrorPopup(message, type='warning', title = "Something Went Wrong!", confirmButtonText = "OK") {
    Swal.fire({
        title: title,
        text: message,
        icon: type,
        confirmButtonText: confirmButtonText,
        allowOutsideClick: false
    });
}

export { alertPopup, confirmPopup, apiErrorPopup };


// WEBPACK FOOTER //
// ./src/helpers/MessagePopup.js